<template>
    <b-container>
        <b-col lg="12" class="no-gutters" v-if="!editMode" >
            <div class="round-btn" @click.stop="addOrganization">
                <i class="fa fa-plus"/>
            </div>
            <h3 class="resource-title mb-5">{{ $t('common.nearby_organizations')}}</h3>
        </b-col>

        <transition name="fade">
            <organization-list
                    v-if="!editMode"
                    :results="results"
                    @edit="editOrganization"
            />
        </transition>

        <transition name="fade">
            <organization-editor
                    v-if="editMode"
                    :organization-id="organizationId"
                    :stripe-auth-code="stripeAuthCode"
                    @close="showList"
                    @closeAndUpdate="closeAndUpdate"
                    @alert="showAlert"
            />
        </transition>

        <div
                v-if="loading"
                id="loader"
                class="spinner"
        />
    </b-container>
</template>


<script>
    import OrganizationList from './OrganizationList'
    import OrganizationEditor from './OrganizationEditor'
    import FairApi from '../../modules/api'

    export default {
        name: 'organizations',
        components: {OrganizationList, OrganizationEditor},
        props: {
            stripeAuthCode: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                results: [],
                organizationId: null,
                editMode: false,
                loading: false
            }
        },
        created: function () {
            this.fetchOrganizations()
            if (this.$store.state.stripeAuthOrganization) {
                this.organizationId = this.$store.state.stripeAuthOrganization
                this.editMode = true
            }
        },
        methods: {
            fetchOrganizations: function () {
                this.loading = true
                FairApi.get(FairApi.organizationAll(), this.fetchOrganizationsSuccess, this.fetchOrganizationsFailed)
            },

            fetchOrganizationsSuccess: function (response) {
                this.results = response
                this.loading = false
            },

            fetchOrganizationsFailed: function (response) {
                this.loading = false
                if (response.status === 401) {
                    this.$emit('logOut')
                }
                this.showAlert(this.$t('common.fetch_failed'))
            },

            editOrganization: function (organization) {
                this.organizationId = organization.id
                this.editMode = true
            },

            addOrganization: function () {
                this.organizationId = null
                this.editMode = true
            },

            showList: function () {
                this.editMode = false
            },

            showAlert: function (message, variant) {
                this.$emit('alert', message, variant)
            },

            closeAndUpdate: function () {
                this.showList()
                this.fetchOrganizations()
            }
        }
    }
</script>
